// extracted by mini-css-extract-plugin
export default {"answer":"DragDrop_answer__FMUEM","container":"DragDrop_container__rHiHF","card":"DragDrop_card__BrBv5"};